// Central brand assets for Zircon Estates
export const BRAND_NAME = 'Zircon Estates';
export const BRAND_TAGLINE = "India's Trusted Luxury Property Platform";
export const BRAND_LOGO_URL = '/logo.png';
